import { combineReducers } from 'redux';
import list from 'asset_level/reducers/asset_level_list_reducers';
import form from 'asset_level/reducers/asset_level_form_reducers';

export const asset_levelReducers = combineReducers({ list, form });



// WEBPACK FOOTER //
// src/modules/secured/modules/asset_level/reducers/index.js